module.exports = __webpack_public_path__ + "static/media/verConteudosVersar.9e951899.svg";